import { PaginationItemNav, PaginationItemPage, PaginationItemJumper } from '.';

export type Page = {
  id: string;
  page: number;
  type: 'page';
};

export type Jumper = {
  id: string;
  type: 'jumper';
};

export type Nav = {
  id: string;
  type: 'nav';
  direction: 'prev' | 'next';
  page: number;
  isDisabled: boolean;
};

export type PaginationItemType = Page | Jumper | Nav;

interface Props {
  item: PaginationItemType;
  urlBase: string;
  current: number;
  localization: {
    next: string;
    prev: string;
    goToPage: string;
  };
}

const PaginationItem = ({ item, localization, urlBase, current }: Props) => {
  switch (item.type) {
    case 'nav': {
      return (
        <PaginationItemNav
          item={item}
          urlBase={urlBase}
          localization={{
            prev: localization.prev,
            next: localization.next,
          }}
        />
      );
    }

    case 'page': {
      return (
        <PaginationItemPage
          item={item}
          current={current}
          urlBase={urlBase}
          localization={{
            goToPage: localization.goToPage,
          }}
        />
      );
    }

    case 'jumper':
      return <PaginationItemJumper />;

    default:
      return null;
  }
};

export default PaginationItem;
